import { render } from "./AppImageLoader.vue?vue&type=template&id=ec0ff164&scoped=true"
import script from "./AppImageLoader.vue?vue&type=script&lang=js"
export * from "./AppImageLoader.vue?vue&type=script&lang=js"

import "./AppImageLoader.vue?vue&type=style&index=0&id=ec0ff164&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0ff164"]])

export default __exports__